import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonSizes } from '../Button';
import { Wrapper } from './styles';
const ChipButton = (_a) => {
    var { isActive, activeBackgroundColor = 'chipButtonActiveBg', inactiveBackgroundColor = 'chipButtonInactiveBg', disabledBackgroundColor = 'chipButtonDisabledBg', activeTextColor = 'chipButtonActiveText', inactiveTextColor = 'chipButtonInactiveText', disabledTextColor = 'chipButtonDisabledText', borderWidth = 1 } = _a, props = __rest(_a, ["isActive", "activeBackgroundColor", "inactiveBackgroundColor", "disabledBackgroundColor", "activeTextColor", "inactiveTextColor", "disabledTextColor", "borderWidth"]);
    return (_jsx(Wrapper, Object.assign({}, props, { size: ButtonSizes.Sm, "$isActive": isActive, "$activeBackgroundColor": activeBackgroundColor, "$inactiveBackgroundColor": inactiveBackgroundColor, "$disabledBackgroundColor": disabledBackgroundColor, "$activeTextColor": activeTextColor, "$inactiveTextColor": inactiveTextColor, "$disabledTextColor": disabledTextColor, "$borderWidth": borderWidth })));
};
/**
 *
 * Displays a Chip Button, based on:
 * https://www.figma.com/file/cgJA7HSgSPQikWHCHblZSd/Landing-Pages?node-id=1528%3A12504
 *
 * Our chip buttons are meant to express navigation _within_ the body of a page,
 * and have active and inactive/selected and unselected states just like tabs
 * and radio buttons.
 *
 * Material Design guidelines talk about chips like this:
 *
 * > Chips allow users to enter information, make selections, filter content, or
 * trigger actions. While buttons are expected to appear consistently and with
 * familiar calls to action, chips should appear dynamically as a group of
 * multiple interactive elements.
 *
 */
export default ChipButton;
//# sourceMappingURL=index.js.map